
export const getLotStatus = (rawStatus) => {
  if(rawStatus === undefined || rawStatus === null)
    return;

  switch (rawStatus) {
    case 'DRFT': return 'Draft';
    case 'BKD': return 'Booked';
    case 'SCRN': return 'Screened';
    case 'TRK': return 'Truck';
    case 'RCS': return 'Ready for Carriage';
    case 'DEP': return 'Departed';
    case 'XFOH': return 'Transfer On Hand';
    case 'ARR': return 'Arrived';
    case 'RCF': return 'Received at Facility';
    case 'DLV': return 'Delivered';
    case 'TFD': return 'Transfer to OAL';
    case 'XOAL': return 'XOAL';
    case 'MSNG': return 'Missing';
    case 'TRC': return 'Escalated';
    case 'LOST': return 'Lost';
    case 'CXLD': return 'Cancelled';
    case 'VOID': return 'Void';
    default: return '';
  }
};


// WEBPACK FOOTER //
// ./src/shared/lotStatus.js